import React, { useEffect, useState } from "react";
import { FormikAsyncSearchComponent } from "../../../utilities/formUtils";
import { Field } from "formik";
import * as select from "../data/selectors";
import { useSelector } from "react-redux";
import { trim } from "lodash";
import { searchItemName } from "../data/actions";
import { setAlertModalState } from "../../common/data/actions";

const ItemNameSearch = (props) => {
    const {
        name,
        className,
        index,
        tabindex,
        placeholder,
        focus,
        isLabel,
        label,
        isTxn,
        isMandatory,
        isSelection,
        disabled,
        isEditMode,
        values,
        dispatch,
        componentType,
        cid,
        onBlurFunction,
        onFocusFunction,
        onKeyUpFunction,
        getValue: callback,
    } = props;

    const options = useSelector((state) => select.getSearchedResults(state, props));
    const isFetching = useSelector((state) => select.getIsFetching(state, props));
    const [queryValue, setQueryValue] = useState("")

    const handleSearchChange = (e, data) => {
        let query = data.value;
        if (trim(query) && trim(query) !== undefined && trim(query) !== null && trim(query) !== "" && trim(query).length > 2) {
            if ('cid' in props && !cid) {
                dispatch(setAlertModalState({
                    isOpen: true,
                    type: "error",
                    size: "mini",
                    title: "Warning",
                    msg: "Please select a Company first before searching."
                }));
                return;
            }
            setQueryValue(query)
        }
    };

    useEffect(() => {
        if (trim(queryValue) && trim(queryValue) !== undefined && trim(queryValue) !== null && trim(queryValue) !== "" && trim(queryValue).length > 0) {
            let payload = {
                srchStr: trim(queryValue),
            }
            const timer = setTimeout(() => dispatch(searchItemName(payload, name, cid)), 500);
            return () => clearTimeout(timer);
        }
    }, [queryValue])

    useEffect(() => {
        if (isEditMode) {
            // Handle edit mode if needed
        }
    }, [isEditMode, componentType])

    const getInputValue = (e, setFieldValue, fieldName, obj, values, index) => {
        if (callback) {
            callback(e, values, setFieldValue, fieldName, obj, dispatch, index);
        }
    };

    const handleOnBlur = (e, setFieldValue, fieldName, obj, values, index) => {
        if (onBlurFunction) {
            onBlurFunction(e, values, setFieldValue, obj, dispatch, index);
        }
    };

    const handleKeyUp = (e, setFieldValue, fieldName, values, index) => {
        if (onKeyUpFunction) {
            onKeyUpFunction(e, setFieldValue, fieldName, values, index);
        }
    };

    const handleFocus = (e, setFieldValue, fieldName, index) => {
        if (onFocusFunction) {
            onFocusFunction(e, setFieldValue, fieldName, index);
        }
    };

    const handleKeyDown = (e, setFieldValue, fieldName, values, index) => {

    }

    return (
        <Field
            name={name}
            component={FormikAsyncSearchComponent}
            handleSearchChange={handleSearchChange}
            tabindex={tabindex}
            userProps={{
                options,
                getInputValue,
                handleOnBlur,
                handleKeyUp,
                handleFocus,
                handleKeyDown,
            }}
            className={className}
            placeholder={placeholder}
            focus={focus ? focus : null}
            isLabel={isLabel}
            label={label}
            isTxn={isTxn}
            isSelection={isSelection}
            disabled={disabled}
            index={index}
            loading={isFetching}
            isMandatory={isMandatory}
        />
    );
};

export default ItemNameSearch
